import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    hnc_prefill_verify_wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        paddingBottom: '4rem',
        margin: '0 0.5rem'
    },
    hnc_prefill_address_wrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        justifyContent: 'start',
        width: '100%',
        marginTop: '0.5rem',
        marginBottom: '5rem',
        '@media (max-device-width: 760px)': {
            flexDirection: 'column',
            width: '100%',
            gap: '2rem'
        }
    },
    postcode_wrapper: {
        flexBasis: '25%',
        marginRight: '1.5rem',
        '@media (max-device-width: 760px)': {
            width: '100%'
        }
    },
    address_wrapper: {
        flexBasis: '75%',
        '@media (max-device-width: 760px)': {
            width: '100%'
        }
    },
    banner_wrapper: {
        width: '100%',
        marginBottom: '2rem'
    },
    header_wrapper: {
        marginTop: '5rem',
        marginBottom: '2rem',
        '@media (max-device-width: 500px)': {
            marginTop: '2rem'
        }
    },
    header_two: {
        marginBottom: '0'
    },
    fieldset: {
        width: '100%'
    },
    fullscreenLoaderWrapper: {
        display: 'flex',
        position: 'fixed',
        zIndex: '100',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.4)'
    },
    errorWrapper: {
        width: '100%',
        marginTop: '5rem',
        '@media (max-device-width: 500px)': {
            marginTop: '4rem',
        }
    }
});
